let globalStyle = {
    themeColor: '#1890ff',
    bgColor: '#f7f7f7',
    // fontColor: '#0B121A',
    fontColor: '#101010',
    // grayColor: '#C0C5CC'
    grayColor: 'rgba(16,16,16,.5)'
}

export default globalStyle